import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';

import { IllustBookmarkCoupon } from '@common/icons';
import { Typography } from '@common/styles';
import { Button, ButtonColor, ButtonSize, Drawer } from '@common/toolbox';

interface Props {
  open: boolean;
  onAccept: () => void;
  onDeny: () => void;
  onClose: () => void;
}

export const BookmarkCouponDrawer: React.FC<React.PropsWithChildren<Props>> = ({ open, onAccept, onDeny, onClose }) => {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      height={'calc(332px + env(safe-area-inset-bottom) + constant(safe-area-inset-bottom))'}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 48px 16px 24px;
          padding-bottom: calc(env(safe-area-inset-bottom) + 24px);
          padding-bottom: calc(constant(safe-area-inset-bottom) + 24px);

          > p {
            margin: 8px 0 0;
          }
        `}
      >
        <IllustBookmarkCoupon />
        <h3 className={Typography.HEAD_20_BOLD}>쿠폰 받아보실래요?</h3>
        <p className={Typography.BODY_15_MEDIUM}>즐겨찾기하고 할인 혜택 받으세요</p>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin: 24px 0 0;
            padding: 0 8px;

            .cancel {
              max-width: 109px;
              width: 100%;
              padding: 0;
              color: ${vars.v3Color.gray500};
            }

            .accept {
              max-width: 218px;
              width: 100%;
            }
          `}
        >
          <Button className='cancel' button_size={ButtonSize.LARGE} onClick={onDeny}>
            안 받을래요
          </Button>
          <Button
            className='accept'
            button_size={ButtonSize.LARGE}
            button_color={ButtonColor.PRIMARY}
            onClick={onAccept}
          >
            즐겨찾기 하고 받기
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
